<template>
  <div class="ui-box" :class="bgType">
    <div class="ui-box-nav">
      <div class="ui-box-nav-left">
        <div class="decorate"></div>
        <div class="nav-bg">
          <div class="prefix"></div>
          <div class="middle"></div>
          <div class="suffix"></div>
        </div>
        <slot name="nav-left"></slot>
      </div>
      <slot name="nav-right"></slot>
    </div>
    <div class="ui-box-container">
      <slot name="container"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    bgType: {
      type: String,
      default: 'dark'
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-box {
  position: relative;
  display: flex;
  flex: 1;
  height: 100%;
  flex-direction: column;
  .ui-box-nav {
    position: relative;
    width: 100%;
    height: get_vh(60px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    // z-index: 2;
    .ui-box-nav-left {
      position: relative;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .decorate {
        position: absolute;
        top: get_vh(-72px);
        right: get_vh(-210px);
        width: get_vh(353px);
        height: get_vh(318px);
        background-image: $bg_decorate;
        background-size: get_vh(1472px) get_vh(639px);
        background-position: get_vh(-762px) get_vh(-103px);
        background-repeat: no-repeat;
      }
      .nav-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        min-width: get_vh(144px);
        height: 129%;
        display: flex;
        display: none;
        .prefix {
          width: get_vh(30px);
          height: 100%;
          background-image: url('https://website.xdcdn.net/poster/58881/20250717/KxquWwzw.png');
          background-size: 100% 100%;
          background-position: center;
          background-repeat: no-repeat;
        }
        .middle {
          flex: 1;
          height: 100%;
          background-image: url('https://website.xdcdn.net/poster/58881/20250717/KxquWe2v.png');
          background-size: contain;
          background-position: center;
          background-repeat: repeat-x;
          margin-left: get_vh(-2px);
          border-radius: 0 get_vh(20px) 0 0;
          overflow: hidden;
        }
        .suffix {
          position: absolute;
          top: 0;
          right: get_vh(-72px);
          width: get_vh(95px);
          height: 100%;
          background-image: url('https://website.xdcdn.net/poster/58881/20250717/KxquWPL3.png');
          background-size: 100% 100%;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
    }
    // .ui-box-nav-right {
    //   display: flex;
    //   height: 100%;
    //   justify-content: flex-end;
    //   align-items: center;
    // }
  }
  .ui-box-container {
    position: relative;
    flex: 1;
    overflow: hidden;
    z-index: 1;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    @include boxShadowSet_Container;
  }

  &.dark {
    .ui-tag {
      &::before {
        background-image: url('https://website.xdcdn.net/poster/58881/20250717/KxkQTIei.png');
      }
      &::after {
        background-image: url('https://website.xdcdn.net/poster/58881/20250717/K7gHcC2c.png');
        display: block;
      }
    }
    .ui-box-nav-left {
      .nav-bg {
        display: flex;
      }
    }
    .ui-box-container {
      background-image: $bg_container_dark;
    }
  }

  &.light {
    .ui-tag {
      &::before {
        background-image: url('https://website.xdcdn.net/poster/58881/20250717/KxmeMpNL.png');
      }
    }
    .ui-box-container {
      background-image: $bg_container_light;
      &::before {
        content: '';
        position: absolute;
        bottom: get_vh(95px);
        left: get_vh(-30px);
        width: get_vh(143px);
        height: get_vh(148px);
        background-image: $bg_decorate;
        background-size: get_vh(1472px) get_vh(639px);
        background-position: get_vh(-1140px) get_vh(-104px);
        background-repeat: no-repeat;
        z-index: -1;
      }
      &::after {
        content: '';
        position: absolute;
        top: get_vh(100px);
        right: get_vh(-20px);
        width: get_vh(120px);
        height: get_vh(110px);
        background-image: $bg_decorate;
        background-size: get_vh(1472px) get_vh(639px);
        background-position: get_vh(-1308px) get_vh(-104px);
        background-repeat: no-repeat;
        z-index: -1;
      }
    }
  }
}

@media screen and (max-aspect-ratio: 3/2) {
  .ui-box {
    .ui-box-nav {
      height: get_vw(60px);
      .ui-box-nav-left {
        .decorate {
          top: get_vw(-72px);
          right: get_vw(-210px);
          width: get_vw(353px);
          height: get_vw(318px);
          background-size: get_vw(1472px) get_vw(639px);
          background-position: get_vw(-762px) get_vw(-103px);
        }
        .nav-bg {
          min-width: get_vw(144px);
          .prefix {
            width: get_vw(30px);
          }
          .middle {
            margin-left: get_vw(-2px);
            border-radius: 0 get_vw(20px) 0 0;
          }
          .suffix {
            right: get_vw(-72px);
            width: get_vw(95px);
          }
        }
      }
    }

    &.light {
      .ui-box-container {
        &::before {
          bottom: get_vw(95px);
          left: get_vw(-30px);
          width: get_vw(143px);
          height: get_vw(148px);
          background-size: get_vw(1472px) get_vw(639px);
          background-position: get_vw(-1140px) get_vw(-104px);
        }
        &::after {
          top: get_vw(100px);
          right: get_vw(-20px);
          width: get_vw(120px);
          height: get_vw(110px);
          background-size: get_vw(1472px) get_vw(639px);
          background-position: get_vw(-1308px) get_vw(-104px);
        }
      }
    }
  }
}
</style>